import axios from '../utils/axios';

const ACTIVITY_LOG_BASE = '/activity-log';

export const activityLogService = {
  /**
   * Get paginated activity logs for the current user's company.
   * @param {Object} params - { page: number, size: number, search?: string }
   * @returns {Promise<{ content: Array, totalElements: number, totalPages: number, ... }>}
   */
  getActivityLogs: async (params = {}) => {
    const { page = 0, size = 25, search } = params;
    const query = new URLSearchParams({ page, size });
    if (search != null && String(search).trim() !== '') {
      query.set('search', search.trim());
    }
    const response = await axios.get(`${ACTIVITY_LOG_BASE}?${query.toString()}`);
    return response.data;
  },
};

export default activityLogService;
